<template>
  <!-- 积分商品 -->
  <div class="integralGoods">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['商品管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleEdit('')"
          >新增积分商品</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">商品分类：</label>
        <el-select
          v-model="searchForm.classify"
          placeholder="商品分类"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <label class="label">商品状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="商品状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value="999"></el-option>
          <el-option label="已启用" value="是"></el-option>
          <el-option label="未启用" value="否"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="entName"
        show-overflow-tooltip
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="商品编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="商品名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="spec"
        label="商品规格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="unit"
        label="包装单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="stock"
        label="库存"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="type"
        label="商品分类"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="floot"
        label="楼层"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="价格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="integral"
        label="兑换积分"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="是否启用"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.status == '是'"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1)"
            >下架</el-button
          >
          <el-button
            v-show="scope.row.status == '否'"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            >上架</el-button
          >
          <!-- <el-button
            v-show="scope.row.status == '否'"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 0)"
            >删除</el-button
          > -->
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 商品编辑 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">商品编辑</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="80px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="商品分类" prop="type">
              <el-select
                v-model="addForm.type"
                placeholder="商品分类"
                style="width: 100%"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="展示楼层" prop="floot">
              <el-select
                v-model="addForm.floot"
                placeholder="展示楼层"
                style="width: 100%"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="addForm.type == '优惠券'"
              label="优惠券"
              prop="couponId"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.couponName"
                readonly
                @click.native="getCoupon('')"
                placeholder="单击选择"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品名称" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="生产厂家" prop="factory">
              <el-input v-model="addForm.factory" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品规格" prop="spec">
              <el-input v-model="addForm.spec" clearable></el-input>
            </el-form-item>
            <el-form-item label="包装单位" prop="unit">
              <el-input v-model="addForm.unit" clearable></el-input>
            </el-form-item>
            <el-form-item label="上传图片" prop="img">
              <img-view :imgList="[{ url: addForm.img, id: 0 }]"> </img-view>
              <upload
                @fileChange="uploadImg"
                accept="image/jpg,image/jpeg,image/png"
              ></upload>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input-number
                v-model="addForm.price"
                :min="0"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="积分" prop="integral">
              <el-input-number
                v-model="addForm.integral"
                :min="0"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="库存" prop="stock">
              <el-input-number
                v-model="addForm.stock"
                :min="0"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <!-- 数据选择 -->
    <tableDialog
      v-if="dialogVisible"
      :title="'优惠券列表'"
      :isMoreSel="false"
      :searchValue="searchCoupon.name"
      :tableData="tableList"
      :tableHead="tableDataHead"
      :currPage.sync="currPageCoupon"
      :allPage="allPageCoupon"
      @search="getCoupon"
      @rowClick="rowClick"
      @hanCurrChange="hanCurrChangeCoupon"
      @close="dialogVisible = false"
    ></tableDialog>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面维护积分商城商品数据</p>
        <p>使用场景：在App积分商城/PC积分商城首页显示</p>
        <p>操作说明：按照表单数据添加即可</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "integralGoods",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      selectedList: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        classify: "",
        status: "999",
        name: "",
      },
      typeList: [
        { text: "热门兑换", value: "热门兑换" },
        { text: "家用电器", value: "家用电器" },
        { text: "生活用品", value: "生活用品" },
        { text: "办公用品", value: "办公用品" },
        { text: "优惠券", value: "优惠券" },
      ],
      /**新增drawer */
      addDrawer: false,
      /**新增表单 */
      addForm: {
        entId: "",
        entName: "",
        couponId: "",
        couponName: "",
        id: "",
        name: "",
        spec: "",
        unit: "",
        factory: "",
        stock: "",
        img: "",
        type: "",
        floot: "",
        price: "",
        integral: "",
      },
      /**新增表单规则 */
      addFormRule: {
        name: [mustFill],
        spec: [mustFill],
        unit: [mustFill],
        factory: [mustFill],
        stock: [mustFill],
        img: [mustFill],
        type: [mustFill],
        floot: [mustFill],
        price: [mustFill],
        integral: [mustFill],
      },
      // 优惠券选择弹框相关
      searchCoupon: {
        name: "",
      },
      dialogVisible: false,
      currPageCoupon: 1,
      allPageCoupon: 0,
      tableList: [],
      tableDataHead: {},

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        Procedure: "Proc_Integral",
        Type: "Integral_Goods_Select",
        Goodsname: this.searchForm.name,
        Status: this.searchForm.status,
        Floottype: this.searchForm.classify,
        PageIndex: this.currPage + "",
        PageSize: this.pageSize + "",
      };
      let type = "DataTable";
      this.$requestSys({
        url:
          "Integral/ashx/ReturnDataTable.ashx?Type=" +
          type +
          "&Json=" +
          encodeURIComponent(JSON.stringify(data)),
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.return_code == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data.map((item) => ({
              entId: item.entid,
              entName: item.entname,
              id: item.goodsid,
              name: item.goodsname,
              spec: item.drug_spec,
              unit: item.package_unit,
              factory: item.drug_factory,
              stock: item.quantity,
              img: item.img_url,
              type: item.GoodsType,
              floot: item.FlootType,
              price: item.Price,
              integral: item.Integral,
              status: item.is_zx,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.handleRefresh();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.handleRefresh();
    },
    /**点击新增 */
    handleAdd() {
      this.$router.push("addIntGoods");
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        row = this.selectedList[0];
        this.changeStatus(row, 0);
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 1) {
        msg = "确定下架吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定上架吗?";
        type = "success";
      } else if (status == 0) {
        msg = "确定删除吗?";
        type = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            Procedure: "Proc_Integral",
            Type: "Integral_Goods_Delete",
            Goodsid: row.id,
            status: status + "",
          };
          let Type = "ExecuteNonQuery";
          this.$requestSys({
            url:
              "Integral/ashx/ReturnDataTable.ashx?Type=" +
              Type +
              "&Json=" +
              encodeURI(JSON.stringify(data)),
            method: "post",
          })
            .then((res) => {
              if (res.return_code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    // 上传图片
    uploadImg(file) {
      if (file.length) {
        var formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "admin/Integral/ashx/PictureUpload.ashx",
          data: formData,
        })
          .then((res) => {
            if (res.return_code == 0) {
              this.addForm.img =
                (res.data && res.data[1] && res.data[1].picture) ||
                this.addForm.img;
              this.$message({
                message: "图片上传成功",
                type: "success",
              });
            } else {
              this.$message({
                message:
                  (res.data && res.data[0] && res.data[0].message) ||
                  "上传失败",
                type: "error",
              });
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    // 获取弹出框表格数据
    getCoupon(val) {
      this.searchCoupon.name = val || this.searchCoupon.name;
      let data = {
        type: "IntegralGoodsChoiceCoupon",
        strWhere: this.searchCoupon.name,
        PageIndex: this.currPageCoupon,
        PageSize: 10,
      };
      let proc = "Proc_Admin_SearchInfo"; // 存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        data: data,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableList = res.content;
            this.tableDataHead = res.fdname;
            this.allPageCoupon = res.recordCount;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanCurrChangeCoupon(val) {
      this.currPageCoupon = val;
      this.getCoupon();
    },
    // 选择单条数据
    rowClick(row) {
      this.addForm.couponId = row.couponCode;
      this.addForm.couponName = row.couponName;
      this.dialogVisible = false;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (const key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addDrawer = false;
    },
    /**点击编辑 */
    handleEdit(row) {
      this.clearForm();
      if (row) {
        let data = {
          Procedure: "Proc_Integral",
          type: "Integral_Goods_SelectByGoodsId",
          goodsid: row.id,
        };
        this.$requestSys({
          url:
            "Integral/ashx/IntegralGoodsOperation.ashx?" +
            this.$changObjQuery(data),
          method: "post",
        })
          .then((res) => {
            if (res.return_code == 0) {
              let item = res.data[0];
              this.addForm.id = item.goodsid;
              this.addForm.couponId = item.couponCode;
              this.addForm.couponName = item.couponName;
              this.addForm.name = item.goodsname;
              this.addForm.spec = item.drug_spec;
              this.addForm.unit = item.package_unit;
              this.addForm.factory = item.drug_factory;
              this.addForm.stock = item.quantity;
              this.addForm.img = item.img_url;
              this.addForm.type = item.GoodsType;
              this.addForm.floot = item.FlootType;
              this.addForm.price = item.Price;
              this.addForm.integral = item.Integral;
              this.addDrawer = true;
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      } else {
        this.addDrawer = true;
      }
    },
    /**提交表单 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          if (this.addForm.type == "优惠券" && !this.addForm.couponId) {
            this.$message({
              message: "请选择优惠券",
              type: "warning",
            });
            return;
          }
          let data = {
            CouponCode: this.addForm.couponId,
            GoodsName: this.addForm.name,
            GoodsSpecifications: this.addForm.spec,
            Unit: this.addForm.unit,
            Floor: this.addForm.floot,
            Classification: this.addForm.type,
            Price: this.addForm.price,
            HiddenUrl: this.addForm.img,
            Integral: this.addForm.integral,
            Vendel: this.addForm.factory,
            Quantity: this.addForm.stock,
            type: "Integral_Goods_Insert",
            Procedure: "Proc_Integral",
          };
          if (this.addForm.id) {
            data = {
              goodsid: this.addForm.id,
              CouponCode: this.addForm.couponId,
              goodsname: this.addForm.name,
              drug_spec: this.addForm.spec,
              package_unit: this.addForm.unit,
              FlootType: this.addForm.floot,
              GoodsType: this.addForm.type,
              Price: this.addForm.price,
              Integral: this.addForm.integral,
              factories_choosing: this.addForm.factory,
              Quantity: this.addForm.stock,
              type: "Integral_Goods_Update",
              Procedure: "Proc_Integral",
              img_url: this.addForm.img,
            };
          }
          this.$requestSys({
            method: "post",
            url:
              "Integral/ashx/IntegralGoodsOperation.ashx?" +
              this.$changObjQuery(data),
          })
            .then((res) => {
              if (res.return_code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
                this.clearForm();
              } else {
                this.$message({
                  message:
                    (res.data && res.data[0] && res.data[0].message) ||
                    "操作失败",
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.integralGoods {
  width: 100%;
  height: 100%;
}
</style>
